const mapCustomProviderOptionsToString = (rpcUrl) => (typeof rpcUrl === 'string' ? rpcUrl : rpcUrl.http);
const resolveRpcUrlFromEvmNetworks = (dynamicChain) => {
    var _a;
    const privateCustomerRpcUrls = (_a = dynamicChain.privateCustomerRpcUrls) !== null && _a !== void 0 ? _a : [];
    const customerRpcUrls = privateCustomerRpcUrls.map(mapCustomProviderOptionsToString);
    return customerRpcUrls.length ? customerRpcUrls : dynamicChain.rpcUrls;
};

export { resolveRpcUrlFromEvmNetworks };
